export default __webpack_public_path__ + "static/media/mouthes.8553df46.png";